import { Switch, Route, Redirect } from 'react-router';
import RoutesTracking from './lists/tracking';
import RoutesHistory from './lists/history';
import RoutesPrep from './lists/preparation';
import NewJourney from './NewJourney';
import JourneyTemplates from './templates';
import useCollectionsEnabled from 'hooks/useCollectionsEnabled';

export interface Option {
  value: number | string;
  name: string;
}

export default function JourneysList() {
  const collectionsEnabled = useCollectionsEnabled();
  return (
    <Switch>
      <Route path="/journeys/draft" component={RoutesPrep} />
      <Route path="/journeys/active" component={RoutesTracking} />
      <Route path="/journeys/history" component={RoutesHistory} />
      <Route
        path="/journeys/new/:kind"
        render={({ match }) =>
          match.params.kind === 'collections' && !collectionsEnabled ? (
            <Redirect to="/journeys/active" />
          ) : (
            <NewJourney />
          )
        }
      />
      {collectionsEnabled && (
        <Route path="/journeys/templates" component={JourneyTemplates} />
      )}
      <Redirect to="/journeys/active" />
    </Switch>
  );
}
